const actions = {
  getUnidades: async (context, { per_page, page, search }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/vendors`, {
      params: {
        per_page,
        page,
        search,
      },
    });

    return response;
  },

  getUnidadesUser: async (context) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/vendors/users`, {
      params: {
        per_page: 100,
      },
    });

    return response;
  },

  deletarUnidade: async (context, { vendor_id, id }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.delete(`/auth/users/${id}/vendors/${vendor_id}`);

    return response;
  },

  ativarUnidade: async (context, { vendor_id, id }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(`/auth/users/${id}/vendors/${vendor_id}`);

    return response;
  },

  auth: async (context) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.post(`auth/me`);

    return response;
  },
};

export const adminPostos = {
  namespaced: true,
  actions,
};
